document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll('.add-cart').forEach(button => button.addEventListener('click', e => {
        if(!button.classList.contains('loading')) {
            button.classList.add('loading');
            setTimeout(() => button.classList.remove('loading'), 3700);
        }
    }));
});
